import { observable, action } from 'mobx';
import { getUrlParam, setCookie, getCookie, changeUrlSearchParam, isNumber, cacheData } from '@/common/utils/commonFunc'
import { checkActiveMenuIdList } from '@/common/utils/menuFunc'
import {
	getPermissions,
	getEnvList,
	getUserInfo,
	getAllCountryAndOrg,
	getDigits,
	getGrayPermissionList,
} from '@/common/js/api'
import locales from '@/locales'
import { message } from 'antd';
import { getLocalStorage, setLocalStorage } from '../common/utils/localStorage';

interface Tenant {
	[key: string]: string;
	[key: number]: string;
}

export interface Country {
	tenants: Tenant[];
	code: string;
	countryTelId: number;
	offset: number;
	name: string;
	offsetName: string;
	jumpTo: string;
}

class CommonStore {
	@observable Domain = window.location.hostname.split('.')[0];
	@observable Cookies: any = {};
	@observable UserInfo: any = {};
	@observable locales: any = locales;
	@observable curLocales: any = {};
	@observable currentEnv: string = 'small'
	@observable hasSubStatus: boolean = false
	@observable isReady: boolean = false
	@observable currCountryCode: string = ''
	@observable currOrganizationId: string = ''
	@observable organization_id: string = ''
	@observable organizationTitle: string = ''
	@observable countryTitle: string = ''
	@observable moduleCountry: any = []
	@observable allCountry: Country[] = []
	@observable organizationList: any = []
	@observable envList: any = []
	@observable hideUrgentMsg: boolean = false
	@observable permissionsObj: any = {}
	// @observable workStatus: any = {} //1：无权限，展示旧版状态条 2：有权限，展示新版状态条 3：运营，不展示任意状态条
	@observable activeMenu: any = {}

	@action
	setSubStatus = (status: boolean) => {
		this.hasSubStatus = status;
	}

	@action
	initSettings() {
		// 设置domain
		if (!localStorage.getItem('domain')) {
			let env = window.location.hostname.split('.')[0]
			this.changeDomain(env)
		}
		return this.initGlobalParams()
	}

	@action
	async initGlobalParams() {
		await this.getUserInfo()
		await Promise.all([
			this.getEnvList(),
			this.initCountryAndOrg()
		])
		this.getDigits()
		this.initPermissions()
		// this.initPermissionsList()
		this.initCookies()
		this.initLocalStorage()
		this.checkCurrentEnv()
		if (this.allCountry.length) {
			this.isReady = true
		}
		return Promise.resolve();
	}

	@action
	getDigits() {
		return getDigits({
			lang: getCookie('javaLang'),
		}).then((res) => {
			setLocalStorage('priceDigits', res?.data?.data >= 0 ? res?.data?.data : 2) // 兜底精确到小数点后两位
		})
	}

	@action
	getUserInfo() {
		return getUserInfo().then((res) => {
			this.setUserInfo(res.data.user || {})
			setCookie('userid', res.data.user.userId, 24)
		})
	}

	@action
	initCountryAndOrg() {
		return getAllCountryAndOrg()
			.then(res => {
				if (res.status === 0) {
					// 如url存在参数，setcookie
					if (getUrlParam('canonical_country_code')) {
						setCookie('canonical_country_code', getUrlParam('canonical_country_code'), 24)
					}
					if (getUrlParam('organization_id')) {
						setCookie('organization_id', getUrlParam('organization_id'), 24)
					}
					if (getUrlParam('lang')) {
						setCookie('lang', getUrlParam('lang'), 24)
					}
					this.allCountry = res.data.countries || []
					this.moduleCountry = res.data.moduleCountries || []
					const countries = [...this.allCountry, ...this.moduleCountry]
					const canonical_country_code = getCookie('canonical_country_code')
					// 取到当前国家
					const defaultCountry = countries.filter((item) => item.jumpTo === window.location.hostname)[0] || countries[0] || {}
					const currCountryCode = countries.some(((item) => item.code === canonical_country_code)) ? canonical_country_code : defaultCountry.code
					const currCountry: Country = countries.filter((item) => item.code === currCountryCode)[0] || {}
					// 取organazationId
					let currOrganizationId = currCountry.tenants.length ? Object.keys(currCountry.tenants[0])[0] : ''
					const cCode = getLocalStorage(`cCode_${getCookie('userid')}_${currCountryCode}`)
					if (cCode && isNumber(cCode.organizationId)) {
						currOrganizationId = cCode.organizationId
						// case 1
					}

					this.currCountryCode = currCountryCode
					this.currOrganizationId = currOrganizationId
					this.setCallback_n(currCountry)
				}
			})
	}
	@action
	setCallback_n(currCountry: Country) {
		let organizationList: any = {}
		currCountry.tenants.forEach((item) => {
			organizationList[Object.keys(item)[0]] = item[Object.keys(item)[0]]
		})
		this.organizationList = organizationList
		// cookie 存储当前信息  清除国家码cookie
		// setCookie('canonical_country_code', currCountry.code, 24)
		// setCookie('utc_offset', currCountry.offset, 24)
		// setCookie('organization_id', this.currOrganizationId, 24)
		// setCookie('countryTelId', currCountry.countryTelId, 24)
		// position存储上次成功登陆的完整信息
		let position: any = {}
		position.canonical_country_code = currCountry.code
		position.countryTelId = currCountry.countryTelId
		position.offset = currCountry.offset
		position.countryTitle = currCountry.name + currCountry.offsetName
		position.organizationId = this.currOrganizationId
		localStorage.setItem(`position_${getCookie('userid')}`, JSON.stringify(position))
		// ccode存储之前成功登录过的国家及业务线信息
		let cCodeName = `cCode_${getCookie('userid')}_${currCountry.code}`
		let cCode = {
			organizationId: this.currOrganizationId,
			organizationTitle: organizationList[this.currOrganizationId]
		}
		localStorage.setItem(cCodeName, JSON.stringify(cCode))
	}


	@action
	initPermissions() {
		const PermissionObj_LocalStorage = `permissionsObj`;
		cacheData(PermissionObj_LocalStorage, getPermissions, (res) => {
			if (res.status === 0) {
				let permissionsObj = {}
				res.data.permissions.forEach((obj: string) => {
					permissionsObj[obj] = 1
				})
				this.permissionsObj = permissionsObj
			}
		})
	}
	// @action
	// initPermissionsList() {
	// 	return getGrayPermissionList().then((res) => {
    //         if (res && res.status === 0 && res.data && res.data.data) {
    //             this.workStatus = res.data.data[0]
    //         }
    //     });
	// }

	@action
	initCookies() {
		const cookieStr = document.cookie || ''
		// eslint-disable-next-line
		cookieStr.split('; ').map(item => {
			let t = item.split('=')
			this.Cookies[t[0]] = t[1]
		})
	}

	@action
	checkCurrentEnv() {
		const xLable = this.Cookies['x-label']
		if (xLable === '' || !xLable) {
			this.currentEnv = 'online'
		} else if (xLable.indexOf('pre') >= 0) {
			this.currentEnv = 'pre'
		}
	}

	@action
	setLocales(lang: string) {
		if (locales[lang]) {
			this.curLocales = locales[lang] || locales['en-US']
		} else {
			// 语言有问题时，重置
			let lang = 'en-US'
			setCookie('lang', lang, 24)
      		setCookie('javaLang', lang.split('-').join('_'), 24)
			window.location.search = changeUrlSearchParam('lang', lang)
		}
	}

	@action
	initLocalStorage() {
		for (let key in this.Cookies) {
			localStorage.setItem(key, this.Cookies[key])
		}
		let lang = getCookie('lang')
		if (getUrlParam('lang') && getUrlParam('lang') !== getCookie('lang')) {
			lang = getUrlParam('lang')
		}
		this.setLocales(lang)
	}

	@action
	setUserInfo(info: any) {
		this.UserInfo = info
	}

	@action
	changeDomain(domain: string) {
		localStorage.setItem('domain', domain)
		window.location.reload();
		this.Domain = domain
	}

	@action
	// 获取环境列表
	getEnvList() {
		const EnvList_LocalStorage = 'EnvList_LocalStorage';
		cacheData(EnvList_LocalStorage, getEnvList, (res) => {
			if (+res.status === 0) {
				if (res.data && res.data.authList) {
					this.hideUrgentMsg = !!res.data.authList.filter
					this.envList = res.data.authList.env && res.data.authList.env.filter((item: string) => item !== 'admin')
				} else {
					message.error('环境切换权限接口数据故障');
				}
			} else {
				message.error('获取环境切换权限接口执行失败');
			}
		})
	}

	// // menu 列表 
	@action
	setActiveMenuIdList(menu: any) {
		const activeMenu = checkActiveMenuIdList(menu)
		this.activeMenu = activeMenu
		return activeMenu
	}

}

export default new CommonStore();